import { API_BASE_URL } from '../api/api'

/** wss://host for the API the app talks to (REACT_APP_API_BASE_URL overrides for local work). */
export function socketBaseUrl() {
  const origin = process.env.REACT_APP_API_BASE_URL || API_BASE_URL.replace(/\/api\/?$/, '')
  return origin.replace(/^http(s?):\/\//, (_m, secure) => (secure ? 'wss://' : 'ws://')).replace(/\/$/, '')
}
